export enum SettingsTab {
  Chart = 'chart',
  Colors = 'colors',
}
export interface ChartTabComponentProps {
  onSubmit: () => void
  onClose: () => void
  onChangeSettingsTab: (tab: SettingsTab) => void
}

export const COMMON_FOOTER_BUTTON_PROPS = {
  size: 'medium',
  theme: 'transparent',
  rightContent: 'arrowForward',
}
